import { render, staticRenderFns } from "./WaterUseAnalysisPage.vue?vue&type=template&id=52053aa0&scoped=true"
import script from "./WaterUseAnalysisPage.vue?vue&type=script&lang=js"
export * from "./WaterUseAnalysisPage.vue?vue&type=script&lang=js"
import style0 from "./WaterUseAnalysisPage.vue?vue&type=style&index=0&id=52053aa0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52053aa0",
  null
  
)

export default component.exports